import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full items-center space-y-6 justify-center" }
const _hoisted_2 = { class: "flex flex-col w-full max-w-xl" }
const _hoisted_3 = { class: "text-lg font-medium text-gray-900 text-left" }
const _hoisted_4 = { class: "p-6 space-y-6" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = { class: "flex flex-row space-x-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 border-l-2 border-gray-200" }, " % ", -1)
const _hoisted_8 = { class: "flex self-end w-1/2 mt-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 border-l-2 border-gray-200" }, " % ", -1)
const _hoisted_10 = { class: "flex flex-row space-x-8" }
const _hoisted_11 = { class: "px-5 border-l-2 border-gray-200" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_13 = {
  key: 0,
  class: "pt-1 mt-1 text-sm text-gray-600 leading-4 border-t border-transparent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HospitalTeamSelect = _resolveComponent("HospitalTeamSelect")!
  const _component_BaseNumberInput = _resolveComponent("BaseNumberInput")!
  const _component_BaseSelect = _resolveComponent("BaseSelect")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.copd.add-patient')), 1)
    ]),
    _createVNode(_component_BaseCard, {
      class: "flex flex-col w-full max-w-xl",
      padding: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.tagsFeatureFlag)
              ? (_openBlock(), _createBlock(_component_HospitalTeamSelect, {
                  key: 0,
                  "hospital-team": _ctx.program.hospital_team,
                  error: _ctx.validationErrors && _ctx.validationErrors.hospital_team && _ctx.validationErrors.hospital_team[0],
                  "onUpdate:hospitalTeam": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateProgram({ hospital_team: $event.id })))
                }, null, 8, ["hospital-team", "error"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_BaseNumberInput, {
              "model-value": `${_ctx.program.settings.spo2_range_low}`,
              "data-dusk": "copd-settings-spo2-min-target",
              class: "w-1/2",
              step: "any",
              "show-button": false,
              label: _ctx.$t('custom.uhb.copd.spo2-target-range'),
              placeholder: "Min",
              error: 
              _ctx.validationErrors &&
                _ctx.validationErrors['settings.spo2_range_low'] &&
                _ctx.validationErrors['settings.spo2_range_low'][0]
            ,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSettings({ spo2_range_low: $event === '' ? $event : +$event })))
            }, {
              "use-default": _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["model-value", "label", "error"]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BaseNumberInput, {
                "model-value": `${_ctx.program.settings.spo2_range_high}`,
                "data-dusk": "copd-settings-spo2-max-target",
                "show-button": false,
                step: "any",
                placeholder: "Max",
                error: 
                _ctx.validationErrors &&
                  _ctx.validationErrors['settings.spo2_range_high'] &&
                  _ctx.validationErrors['settings.spo2_range_high'][0]
              ,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSettings({ spo2_range_high: $event === '' ? $event : +$event })))
              }, {
                "use-default": _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["model-value", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_BaseSelect, {
              "data-dusk": "copd-settings-inspired-oxygen",
              "model-value": _ctx.oxygenValue,
              class: _normalizeClass(_ctx.showFlowRate ? 'w-1/2' : 'w-full'),
              label: _ctx.inspiredOxygenLabel,
              placeholder: _ctx.inspiredOxygenPlaceholder,
              options: _ctx.oxygenTypes && _ctx.oxygenTypes.toOptions(),
              error: 
              _ctx.validationErrors &&
                _ctx.validationErrors['settings.method_of_oxygen_delivery'] &&
                _ctx.validationErrors['settings.method_of_oxygen_delivery'][0]
            ,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSettings({ method_of_oxygen_delivery: _ctx.oxygenTypes.find($event) })))
            }, null, 8, ["model-value", "class", "label", "placeholder", "options", "error"]),
            (_ctx.showFlowRate)
              ? (_openBlock(), _createBlock(_component_BaseNumberInput, {
                  key: 0,
                  "model-value": _ctx.program.settings.flow_rate,
                  "data-dusk": "copd-settings-flow-rate",
                  class: "w-1/2",
                  step: "any",
                  min: "0",
                  max: "15",
                  "show-button": false,
                  label: _ctx.flowRateLabel,
                  error: 
              _ctx.validationErrors && _ctx.validationErrors['settings.flow_rate'] && _ctx.validationErrors['settings.flow_rate'][0]
            ,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSettings({ flow_rate: $event })))
                }, {
                  "use-default": _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('custom.uhb.copd.litres-per-min')), 1)
                  ]),
                  _: 1
                }, 8, ["model-value", "label", "error"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.tagsFeatureFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_RadioGroup, {
                  label: _ctx.$t('custom.uhb.copd.is-the-patient-home-monitoring'),
                  options: _ctx.homeMonitoringValues,
                  "model-value": _ctx.selectedHomeMonitoringOption,
                  error: _ctx.homeMonitoringValidationError,
                  "label-position": "left",
                  "data-dusk": "home-monitoring-options",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateHomeMonitoringOption($event)))
                }, null, 8, ["label", "options", "model-value", "error"]),
                (!_ctx.homeMonitoringValidationError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('custom.uhb.copd.where-patient-will-record-at-home')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}